import type React from 'react';
import { Tooltip, TriggerText } from '@zillow/constellation-10';

type Props = {
  tooltipBodyText: string | React.ReactNode;
  children: string | React.ReactNode;
  closeWith?: Array<string>;
  openWith?: Array<string>;
  shouldCloseOnOutsideClick?: boolean;
};

InlineTooltip.defaultProps = {
  closeWith: ['blur'],
  openWith: ['focus', 'click', 'mouseEnter'],
  shouldCloseOnOutsideClick: true,
};

export default function InlineTooltip({ tooltipBodyText, children }: Props): JSX.Element {
  return (
    <Tooltip
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      content={tooltipBodyText as any}
      onOpenChange={function noop() {}}
      placement="top"
      shouldAwaitInteractionResponse
      trigger={<TriggerText>{children}</TriggerText>}
    />
  );
}
